import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LogLinkedInMessageIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogLinkedInMessage",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.79 7.07H7.52V4.71c0-.61-.53-1.05-1.05-1.05s-1.14.44-1.14 1.05v2.28H3.06c-.53 0-1.05.52-1.05 1.14s.53 1.05 1.05 1.05h2.27v2.27c0 .61.44 1.05 1.05 1.05s1.05-.53 1.05-1.05V9.18H9.7c.61 0 1.05-.52 1.05-1.05s-.35-1.05-.96-1.05ZM30 24.83V12.75c0-2.01-1.57-3.67-3.59-3.67H14.34c-2.01 0-3.59 1.66-3.59 3.59v12.07c0 2.01 1.66 3.59 3.59 3.59h12.08c1.92.09 3.59-1.57 3.59-3.5Zm-13.39.44h-2.89v-8.75h2.89zm-1.31-9.89h-.35c-.88 0-1.49-.7-1.49-1.49s.7-1.49 1.49-1.49h.35c.88 0 1.49.7 1.49 1.49s-.7 1.49-1.49 1.49m11.73 9.89h-2.97v-4.64c0-1.22-.44-2.01-1.49-2.01-.7 0-1.22.44-1.49 1.05-.09.18-.09.44-.09.61v4.99H18.1v-8.75h2.89v1.22c.53-.88 1.49-1.49 2.54-1.49h.09c1.93 0 3.32 1.23 3.32 3.94l.09 5.07Zm-5.86-5.6"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.71 14.57c-.63 0-1.14-.51-1.14-1.14V2a1.14 1.14 0 1 1 2.28 0v11.43c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.43 8.86H2a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28M12.59 18.38h3.79v12.19h-3.79zm1.89-6.06c1.21 0 2.2.98 2.2 2.2s-.98 2.2-2.2 2.2-2.2-.98-2.2-2.2.98-2.2 2.2-2.2M18.75 18.38h3.64v1.67h.05c.51-.96 1.74-1.97 3.58-1.97 3.84 0 4.55 2.52 4.55 5.81v6.69h-3.79v-5.93c0-1.41-.02-3.23-1.97-3.23s-2.27 1.54-2.27 3.13v6.03h-3.79V18.39Z"
      })]
    })
  }));
};